<template>
  <div class="card-area container-fluid">
    <div class="row" v-for="row in rows" :key="row">
      <card v-for="card in row" :key="card.word" v-bind:card="card" v-bind:view="view" v-on:revealCard="revealCard(card)"></card>
    </div>
  </div>
</template>

<script>
import Card from './Card/Card.vue'
import { CardState } from '../../../constants'
import { roomsRef } from '../../../firebase'

export default {
    props: ["room", "view"],
    components: {
        'card': Card
    },
    data() {
        return {
            text:"CardArea",
            cardsRef: roomsRef.child(this.room['.key']).child('cards'),
        }
    },
    computed: {
      rows: function() {
        var rows = [];
        for(let i = 0; i < this.room.cards.length; i += 5){
          rows.push(this.room.cards.slice(i, i + 5));
        }
        return rows
      }
    },
    methods: {
      revealCard: function(card) {
        this.cardsRef.child(this.room.cards.indexOf(card)).update({state: CardState.REVEALED});
      }
    }
}
</script>

<style lang="stylus">
.card-area 
  & .col
    margin 5px
    padding 0
</style>
